/**
 * Created by anthony on 1/8/15.
 */
var ismangularlib = angular.module('ismAngularLib', []);